<div class="container">
    <footer class="pt-3 mt-4 text-body-secondary border-top">
        <app-company-link [pageHome]="true"></app-company-link>
    </footer>
</div>
